import * as React from 'react';
var _path;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SvgHamburgerLine = function SvgHamburgerLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 25.868"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.329 1.342H.671A.671.671 0 0 1 .671 0h30.658a.67.67 0 1 1 0 1.342M31.329 13.605H.671a.671.671 0 0 1 0-1.342h30.658a.67.67 0 1 1 0 1.342M31.329 25.868H.671a.67.67 0 1 1 0-1.342h30.658a.67.67 0 1 1 0 1.342"
  })));
};
export { SvgHamburgerLine as default };